import React from 'react';
import { useSeenModulePixel } from 'hook/helper.hook';
import SectionContainer from 'components/Containers/SectionContainer';
import { Row } from 'components/Containers/Row/Row';
import Disclaimer from 'components/AdvertiserToolTip';
import HeadTextSection from 'components/HeadTextSection';
import RowGrid from 'components/Containers/RowGrid';
import StaticOfferContainer from 'partial/OfferManager/StaticOfferContainer';
import { getViewModuleTrackingAttributes } from 'helpers/tracking.helpers';
import { MARKETPLACE_BUSINESS_OFFERS } from 'types/morph.pagePosition.constants';
import { BUSINESS_LOAN_MARKETPLACE } from 'types/mrph.pageName.constants';
import { OfferModuleWrapper } from 'partial/OfferModuleWrapper/OfferModuleWrapperController';
import Label from 'components/form/Label/Label';

const BusinessLoansOffersView = props => {
  const { offers, modulePosition, isOfferError } = props;

  const seenPixel = useSeenModulePixel(
    getViewModuleTrackingAttributes(
      MARKETPLACE_BUSINESS_OFFERS,
      modulePosition,
      null,
      BUSINESS_LOAN_MARKETPLACE,
    ),
  );

  return (
    <>
      {seenPixel}
      <HeadTextSection
        sectionTitle="Did you know?"
        sectionParagraph="Your personal credit score is an important factor lenders look at for
        your business loan. Often the better the score the better the rate."
      />
      <Row fullWidth className="flex-container justify-end">
        <Disclaimer />
      </Row>
      <OfferModuleWrapper isOfferError={isOfferError}>
        <SectionContainer className="sectionContainer margT8 m-padTB24 m-padLR16">
          <Label
            typeHeader={'h4'}
            className="text-28 bold margB24 m-text-20 m-margB16 padLR48 m-padLR16"
          >
            Your Best Offers
          </Label>
          <RowGrid isOnlyMobile>
            <StaticOfferContainer
              {...props}
              offerMetadataList={offers}
              pagePosition={MARKETPLACE_BUSINESS_OFFERS}
              modulePosition={modulePosition}
              showOfferDetail={props.setOfferDetail}
            />
          </RowGrid>
        </SectionContainer>
      </OfferModuleWrapper>
    </>
  );
};

export default BusinessLoansOffersView;
